/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rating_Very_SatisfiedInputs */

const sv_rating_very_satisfied = /** @type {(inputs: Rating_Very_SatisfiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mycket nöjd`)
};

const en_rating_very_satisfied = /** @type {(inputs: Rating_Very_SatisfiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Very satisfied`)
};

/**
* | output |
* | --- |
* | "Very satisfied" |
*
* @param {Rating_Very_SatisfiedInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const rating_very_satisfied = /** @type {((inputs?: Rating_Very_SatisfiedInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rating_Very_SatisfiedInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_rating_very_satisfied(inputs)
	return en_rating_very_satisfied(inputs)
});